import PasswordRecoveryServiceImpl from "./services/passwordRecoveryServiceImpl";
import LoginServiceImpl from "./services/loginServiceImpl";
import OperatorsManagementServiceImpl from "./services/operatorsManagementServiceImpl";
import NotificationsServiceImpl from "./services/notificationsServiceImpl";
import newsTutorialServiceImpl from "./services/newsTutorialServiceImpl";
import FAQServiceImpl from "./services/FAQServiceImpl";
import ContactsServiceImpl from "./services/contactServiceImpl";
import AppointmentsServiceImpl from "./services/appointmentsServiceImpl";
import BillsServiceImpl from "./services/billsServiceImpl";
import MembersServiceImpl from "./services/membersServiceImpl";
import BookingsService from "./services/bookingsService";
import HFManagementServiceImpl from "./services/HFManagementServiceImpl";
import hfOfficesServiceImpl from "./services/hfOfficesService";
import profileServiceImpl from "./services/profileServiceImpl";

/**
 * This script decouples the logic to backend, every service is intended to be called
 * and instanced only from the store script associated, it's not an abstract level to
 * call services
 */
let PasswordRecoveryService;
let LoginService;
let OperatorsManagementService;
let NotificationsService;
let NewsTutorialService;
let FAQService;
let ContactsService;
let AppointmentsManagementService;
let MembersService;
let BillsService;
let bookingsService;
let HFOfficesService;
let HFManagementService;
let ProfileService;

PasswordRecoveryService = new PasswordRecoveryServiceImpl();
LoginService = new LoginServiceImpl();
OperatorsManagementService = new OperatorsManagementServiceImpl();
NotificationsService = new NotificationsServiceImpl();
NewsTutorialService = new newsTutorialServiceImpl();
FAQService = new FAQServiceImpl();
ContactsService = new ContactsServiceImpl();
AppointmentsManagementService = new AppointmentsServiceImpl();
MembersService = new MembersServiceImpl();
bookingsService = new BookingsService();
BillsService = new BillsServiceImpl();
HFOfficesService = new hfOfficesServiceImpl();
HFManagementService = new HFManagementServiceImpl();
ProfileService = new profileServiceImpl();

let services = {
  passwordRecoveryService: PasswordRecoveryService,
  loginService: LoginService,
  operatorsManagementService: OperatorsManagementService,
  notificationsService: NotificationsService,
  newsTutorialService: NewsTutorialService,
  faqService: FAQService,
  contactService: ContactsService,
  appointmentsService: AppointmentsManagementService,
  membersService: MembersService,
  billsService: BillsService,
  bookingsService,
  hfOfficesService: HFOfficesService,
  hfManagementService: HFManagementService,
  profileService: ProfileService
};

export default services;
